<template lang="html">
	<section class="legals-layout take-place column">
		<div class="legals-master column">
			<div class="legals-title">
				Mentions Légales
			</div>
			<div class="legals-body">
				<div class="legals-section-title" style="font-weight: bold;">Éditeur du site internet</div>
				<div class="item">Ce site internet est édité par la société Patrimoffice, Société par Actions Simplifiée (SAS) au capital de 1.800,00 € entièrement libéré (SIREN : 829 888 122 R.C.S. Paris). Son siège social est au 7 avenue Ingres, 75016 Paris.</div>
				<div class="item">Numéro de TVA intracommunautaire : FR07829888122.</div>
				<div class="item">Mail de contact : contact@patrimoffice.com.</div>

				<div class="legals-section-title" style="font-weight: bold;">Directeur de la publication</div>
				<div class="item">Olivier Potellet.</div>

				<div class="legals-section-title" style="font-weight: bold;">Hébergement</div>
				<div class="item">Le site patrimoffice.com est hébergé par la société Amazon Web Services, Inc., dont le siège social est situé P.O. Box 81226 Seattle, WA 98108-1226 (https://aws.amazon.com).</div>

				<div class="legals-section-title" style="font-weight: bold;">Propriété intellectuelle</div>
				<div class="item">Ce site internet et l'ensemble de ses contenus, tels que notamment, sans que cette liste ne soit limitative, les textes, informations, documentations, documents sonores, photographies, dessins, plans, marques, progiciels, logiciels, données, bases de données, charte graphique, visuels, avatars, et plus généralement tout élément apparaissant sur le site internet, sont protégés par le droit de la propriété intellectuelle et sont la propriété exclusive de Patrimoffice.</div>
			</div>
		</div>
	</section>
</template>

<script>
export default {
}
</script>

<style lang="css">
.legals-section-title {
	font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// Legals.vue?7928ebad